export class Manufacturer {
  isActive: boolean;
  manufacturerId: string;
  manufacturerName?: string;
}
